import {
  MORAL_CREATE, MORAL_CREATE_FAILURE, MORAL_CREATE_SUCCESS,
  MORAL_IMAGE_UPLOAD, MORAL_IMAGE_UPLOAD_FAILURE, MORAL_IMAGE_UPLOAD_SUCCESS,
  MORAL_ALL_GET, MORAL_ALL_GET_FAILURE, MORAL_ALL_GET_SUCCESS

} from './mutation-types'

export default {
  state: {
    moralUploadSuccess: false,
    moralUploadError: false,
    moralAll: []
  },
  getters: {
    moralImageUploadSuccess: state => {
      return state.moralUploadSuccess
    },
    moralImageUploadError: state => {
      return state.moralUploadError
    },
    moralAll: state => {
      return state.moralAll
    }
  },
  actions: {
    [MORAL_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/morals', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MORAL_CREATE_FAILURE, res.data)
            } else {
              commit(MORAL_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          params.errorCallback()
          throw error
        })
    },
    [MORAL_IMAGE_UPLOAD] ({dispatch, state, commit}, params) {
      state.moralUploadSuccess = false
      state.moralUploadError = false

      dispatch('apiPatch', { url: '/master/morals/image_upload', data: params.data, loadparams: false })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MORAL_IMAGE_UPLOAD_FAILURE, res.data)
            } else {
              commit(MORAL_IMAGE_UPLOAD_SUCCESS, { data: res.data, callback: params.callback, index: params.index })
            }
          }
        })
        .catch(error => {
          state.moralUploadError = true
          throw error
        })
    },
    [MORAL_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/morals/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_ALL_GET_FAILURE, res.data)
          } else {
            commit(MORAL_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }

  },
  mutations: {
    [MORAL_CREATE_FAILURE] (state, data) {
      console.log('MORAL_CREATE_FAILURE')
    },
    [MORAL_CREATE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    },
    [MORAL_IMAGE_UPLOAD_FAILURE] (state, data) {
      console.log('MORAL_IMAGE_UPLOAD_FAILURE')
      state.moralUploadError = true
    },
    [MORAL_IMAGE_UPLOAD_SUCCESS] (state, data) {
      console.log('MORAL_IMAGE_UPLOAD_SUCCESS')
      state.moralUploadSuccess = true
      data.callback(data.index, data.data)
    },
    [MORAL_ALL_GET_FAILURE] (state, data) {
      console.log('MORAL_ALL_GET_FAILURE')
    },
    [MORAL_ALL_GET_SUCCESS] (state, data) {
      console.log('MORAL_ALL_GET_SUCCESS')
      state.moralAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/moral-new.js